import React, { useState } from 'react'
import { C } from '../../shared/theme'

// Product thumbnail (`.prod-thumb` 32px, `.cart-thumb` 30px — `size`). Falls back to a gray tile with the
// name's first letter when there's no image URL or it fails to load.
export const ProductThumb: React.FC<{
  src: string
  name: string
  size?: number
}> = ({ src, name, size = 32 }) => {
  const [failed, setFailed] = useState(false)
  const box: React.CSSProperties = {
    width: size,
    height: size,
    borderRadius: 6,
    flexShrink: 0,
  }
  if (!src || failed) {
    return (
      <div
        aria-hidden
        style={{
          ...box,
          background: C.gray[100],
          display: 'grid',
          placeItems: 'center',
          fontSize: 13,
          fontWeight: 600,
          color: C.gray[500],
        }}
      >
        {(name.trim()[0] ?? '?').toUpperCase()}
      </div>
    )
  }
  return (
    <img
      src={src}
      alt=""
      loading="lazy"
      onError={() => setFailed(true)}
      style={{ ...box, objectFit: 'cover', background: C.gray[100] }}
    />
  )
}
